import CommonModal from "../../components/shared/modalLayout/CommonModal";
import Button from "../../components/shared/buttons/button";
import { showToast } from "../../helpers/Utils";

export default function RedemptionCodeSuccessModal({ show, setShow, code }) {
  const handleClose = () => setShow(false);

  const handleCopyAndDone = async () => {
    if (code) {
      try {
        await navigator.clipboard.writeText(code);
        showToast("Code copied", "success");
      } catch (_err) {
        showToast("Could not copy code", "error");
      }
    }
    handleClose();
  };

  return (
    <CommonModal
      show={show}
      setShow={handleClose}
      title="Success"
      className="redemption-success-modal"
      centered
    >
      <div className="redemption-success-code mb-4">{code}</div>
      <div className="redemption-success-actions">
        <Button type="button" label="Copy & Done" onClick={handleCopyAndDone} />
      </div>
    </CommonModal>
  );
}
